import React, { useState, useEffect } from 'react'
import { defer, Outlet, redirect, useLocation, LoaderFunction } from 'react-router-dom'
// import { MpHeader } from '../shared/organism/MpHeader'
import {
  fetchBrokers,
  fetchPeopleFinderProfile,
  selectBrokers,
} from 'shared/redux/peopleFinder/PeopleFinderSlice'
import message from 'shared/assets/icons/messenger.png'
import { useInboxSocket } from '../../utils/hooks/useInboxSocket'
import { persistor, store } from '../../redux/store'
import { FetchProfile, selectProfile, ProfileSelectors, FetchBrokersRequireUserRemoval } from 'shared/redux/profile/ProfileSlice'
import { fetchAlerts } from 'shared/redux/alert/AlertSlice'
import {
  checkPendingOffers,
  fetchGrants,
  fetchProducts,
} from '../../redux/product/ProductSlice'
import { Logger } from '@meprism/app-utils'
import { Box, useMediaQuery } from '@mui/material'
import { theme } from '../../theme/DashboardTheme'

import MultiStepProfileCompletionModal from '../shared/molecule/getting-started-modals/MultiStepProfileCompletionModal'
import { useAppSelector } from '../../redux/storeExports'
import {fetchFamilyStatus, selectActiveGrant, selectFamilyStatus, fetchSubscriptionSchedule} from 'shared/redux/product/ProductSlice'
import { setFamilyPromptCookie, shouldShowProfileCompletionAlert, shouldShowGettingStartedModal } from '../../utils/helpers'
// import { MpHeader } from '../shared/organism/MpHeader'

// 3 hours in milliseconds
export const timeElapsed: number = 3 * 60 * 60 * 1000

enum ModalType {
  PROFILE_COMPLETION = 'profileCompletion',
}

export const mainLayoutLoader: LoaderFunction = async ({ request }) => {
  // Wait for persist rehydration
  persistor.persist()
  if (!persistor.getState().bootstrapped) {
    await new Promise((resolve) => {
      const unsubscribe = persistor.subscribe(() => {
        if (persistor.getState().bootstrapped) {
          unsubscribe();
          resolve(true);
        }
      });
    });
  }
  const state = store.getState();
  const previousFetchTime = state.peopleFinder.previousFetchTime;
  const now = new Date().getTime();
  const user = ProfileSelectors.selectProfile(state);
  try {
    store.dispatch(fetchAlerts())
    const grants = await store.dispatch(fetchGrants()).unwrap()
    store.dispatch(fetchProducts())
    await store.dispatch(fetchSubscriptionSchedule())
    store.dispatch(checkPendingOffers())
    store.dispatch(fetchFamilyStatus())
    const peopleFinderProfile = store
      .dispatch(fetchPeopleFinderProfile())
      .unwrap()
    const brokerList = user?.scan_completed_mail_sent_at && (!previousFetchTime || (now - previousFetchTime >= timeElapsed))
      ? await store.dispatch(fetchBrokers())
      : state.peopleFinder.brokers
    const profile = await store.dispatch(FetchProfile()).unwrap()
    await store.dispatch(FetchBrokersRequireUserRemoval()).unwrap()
    return defer({ 
      peopleFinderProfile, 
      brokerList, 
      profile,
      grants 
    })
  } catch (error) {
    Logger.error(`Error fetching : ${error} ${error?.message}`)
    const searchParams = new URL(request.url).search
    return redirect(`/onboarding${searchParams}`)
  }
}

export const MainLayout = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [activeModal, setActiveModal] = useState<ModalType | null>(null)
  const grants = useAppSelector(selectActiveGrant)
  const profile= useAppSelector(selectProfile)
  const brokerList = useAppSelector(selectBrokers)
  const location = useLocation()
  const familyPlan = useAppSelector(selectFamilyStatus)
  const brokersRequireRemoval = useAppSelector(ProfileSelectors.selectBrokersRequireRemoval)
  const shouldShowFamilyPlanModal =
    grants?.sku?.includes('fam') &&
    !familyPlan?.email &&
    location.pathname !== '/subscribe/success';
  

  useEffect(()=>{
    if(shouldShowFamilyPlanModal){
      setFamilyPromptCookie()
    }
  },[grants, familyPlan, shouldShowFamilyPlanModal])

  const shouldHideModal = location.pathname === '/subscribe/success' || location.pathname === '/dashboard/profile'
  useEffect(() => {
    const needsGettingStarted = shouldShowGettingStartedModal(profile, grants, brokerList.length, brokersRequireRemoval, familyPlan)

    if (shouldHideModal) {
      setActiveModal(null)
      return
    }

    if (needsGettingStarted) {
      setActiveModal(ModalType.PROFILE_COMPLETION)
    }
  }, [grants, profile, shouldHideModal,  brokerList.length, brokersRequireRemoval, familyPlan])

  useInboxSocket({ fqdn: process.env.REACT_APP_API_FQDN as string })
  const stylesbottom = {
    bottomRightIcon: {
      position: 'fixed',
      bottom: 20,
      zIndex: 9999,
      right: 20
    },
  }
  return (
    <>
      {/* <MpHeader /> */}

      <Outlet context={{ isGettingStartedOpen: activeModal === ModalType.PROFILE_COMPLETION }} />
      {!isMobile && <Box sx={{ ...stylesbottom.bottomRightIcon, cursor: 'pointer' }}>
        <img
          src={message}
          id={'intercom-launcher'}
          alt="Description of the image"
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            marginRight: '10px',
          }}
        /></Box>}
      <MultiStepProfileCompletionModal
        open={activeModal === ModalType.PROFILE_COMPLETION}
        setOpen={() => setActiveModal(null)}
        profile={profile}
        grants={grants || null}
        brokerListLength={brokerList.length}
        shouldShowProfileCompletionAlert={shouldShowProfileCompletionAlert}
      />

    </>
  )
}
